import { ChartLoading, UserWordCountChart } from "@vericus/cadmus-common";

import { UserFragment } from "@/generated/graphql";

import { useWordCountActivity } from "../api/use-word-count-activity";
import { DateRange } from "../types";

interface Props {
  assessmentId: string;
  // Work ID
  workId: string;
  // Callback to update date ranges
  setSelectedDateRange: (dateRange: DateRange) => void;
  // Selected date range
  selectedDateRange: DateRange;
  // Members of the group
  members: UserFragment[];
}

export function WordCountChart(props: Props) {
  const { data, isLoading } = useWordCountActivity(
    props.assessmentId,
    props.workId,
    props.members.map((m) => m.id),
    props.selectedDateRange
  );

  if (isLoading) {
    <ChartLoading />;
  }

  return (
    <UserWordCountChart
      data={data?.student_word_counts}
      users={props.members}
    />
  );
}
